const LeadOperationFormField = {
  Quantity: 'quantity',
  PID: 'pid',
  CID: 'cid'
}

export default LeadOperationFormField
